import {
  combineReducers,
  createStore as reduxCreateStore,
  applyMiddleware,
  compose,
} from 'redux';
import thunk from 'redux-thunk';
import * as reducers from './reducers';

export const createStore = () => {
  const reducer = combineReducers(reducers);
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return reduxCreateStore(reducer, composeEnhancers(applyMiddleware(thunk)));
};
